import React, { useEffect, useState, useMemo } from "react";
import { RingLoader } from "react-spinners";
import RegistrationForm from "../Registration/RegistrationForm";
import Footer from "../Footer/Footer";
import Nav from "../Nav";
import Navbar from "../Navbar";

function LoadReg() {
  const [loading, setLoading] = useState(true);
  const [colorIndex, setColorIndex] = useState(0);
  const [countdown, setCountdown] = useState(5); // Set the initial countdown value

  // Memoize the colors array
  const colors = useMemo(
    () => ["#24dd10", "#ee5504", "#0077cc", "#ee0303"],
    []
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
    }, 1000);

    return () => clearInterval(interval);
  }, [colors]);

  useEffect(() => {
    const delayInterval = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    // Set loading to false after the specified delay
    setTimeout(() => {
      setLoading(false);
      clearInterval(delayInterval);
    }, 5000); // Adjust the delay time as needed

    return () => clearInterval(delayInterval);
  }, []);

  return (
    <div>
      {loading && (
        <div>
          <Nav />
          <Navbar />
          <div
            className="countdown-message bg-gray-200 font-semibold text-[23px] pt-1 pb-1 "
            style={{ color: colors[colorIndex] }}
          >
            Please wait: {countdown} seconds
          </div>
        </div>
      )}
      <div className="flex items-center justify-center min-h-screen bg-gray-200">
        {loading ? (
          <div className="flex flex-col items-center mt-2">
            <RingLoader
              color={colors[colorIndex]}
              loading={loading}
              size={200}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
            {/* ... rest of your code remains unchanged */}
            <p className="mt-4 text-[35px] font-bold text-gray-800">KIPPRA</p>
            <p className="mt-4 text-[18px] font-bold text-gray-800">
              The Kenya Institute For Public Policy Research And Analysis
            </p>
            <p className="mt-3 text-green-500 text-[15px]">
              Accelerating Economic Growth and Development for ASALs in Kenya
            </p>
            <div className="mb-0 mt-10">
              <Footer />
            </div>
          </div>
        ) : (
          <RegistrationForm />
        )}
      </div>
    </div>
  );
}

export default LoadReg;
